export default defineNuxtRouteMiddleware((to, from) => {
  if (
    import.meta.client &&
    !navigator.onLine &&
    !to.path.includes("offline")
  ) {
    return "/offline";
  }
});
